import APIController from '../core-api-controller';

export const fetchVouchersApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/vouchers${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchVouchersIntakeAppointmentApi = (id) => {
  const path = `${APIController.endpointApi}/vouchers/${id}/intake_appointment`;
  return APIController.getApiCallback(path);
};

export const sendAppointmentBookingLinkApi = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/vouchers/${id}/send_appointment_booking_link`;
  return APIController.postCallback(path, data);
};

export const fetchVoucherLabReviewsApi = (voucherId = '') => {
  const path = `${APIController.endpointApi}/vouchers/${voucherId}/lab_review`;
  return APIController.getApiCallback(path);
};
